import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CoursesList, { OrderParams } from '@/components/shared/CoursesList';
import HorizontalList from '@/components/shared/HorizontalList';
import { IPaginationParams } from '@/interfaces/pagination';
import { shelvesApi, useGetShelvesQuery } from '@/services/shelves';

import Card from '../MyCourses/Card';

const ShelfCourses = () => {
  const [refetch, { data: response, isFetching }] = shelvesApi.endpoints.getShelf.useLazyQuery({});
  const { shelfId } = useParams();
  const { data } = useGetShelvesQuery();

  const currentShelf = data?.find(item => item.id.toString() === shelfId);
  const currentShelfTitle = currentShelf ? `Trilha "${currentShelf?.title}"` : null;
  const onChoseFilter = useCallback(
    (order: OrderParams) => {
      refetch({ ...order, page: 1, size: 100, id: parseInt(shelfId) });
    },
    [refetch, shelfId]
  );

  const onReachedEnd = useCallback(
    (params: IPaginationParams) => {
      refetch({
        ...params,
        id: parseInt(shelfId)
      });
    },
    [refetch, shelfId]
  );

  const onComponentLoad = useCallback(() => {
    refetch({ page: 1, size: 20, id: parseInt(shelfId) });
  }, [refetch, shelfId]);

  useEffect(() => {
    refetch({ id: parseInt(shelfId), page: 1, size: 50 });
  }, [refetch, shelfId]);

  return (
    <CoursesList
      onChoseFilter={onChoseFilter}
      onComponentLoad={onComponentLoad}
      onReachPageEnd={onReachedEnd}
      queryProps={{ data: response, isFetching }}
      title={currentShelfTitle}
      hasFilter={false}
    >
      <HorizontalList isFetching={isFetching}>
        {response?.data.map(course => (
          <Card {...course} key={course.id} />
        ))}
      </HorizontalList>
    </CoursesList>
  );
};

export default ShelfCourses;
